import { Controller } from "@hotwired/stimulus"

// Opens/collapses the admin background-jobs dock and remembers the choice
// in the session so it sticks from one page load to the next.
export default class extends Controller {
  static values = { url: String }

  toggle() {
    const open = this.element.dataset.open !== "true"
    this.element.dataset.open = String(open)

    fetch(this.urlValue, {
      method: "PATCH",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      },
      body: JSON.stringify({ open })
    })
  }
}
